<div class="campaign-summary-card" [class.is-clickable]="isClickable" (click)="isClickable && action && action()">
  <div class="card-icon">
    <ng-content></ng-content>
  </div>
  <div class="card-value">{{ value }}</div>
  <div class="card-label">{{ label }}</div>
</div>
